<template>
  <div>
    <template v-if="disabled">
      <slot />
    </template>
    <sword-popover-wuk v-else class="attention-level-popover">
      <slot />
      <template #content>
        <h6 class="title t4 -mt_0 -mb_1">{{ $t("patients_funnel_mal") }}</h6>
        <sword-radio-group-wuk
          :checked="option || ''"
          :options="Object.values(options)"
          fill-bg
          variant="minimal"
          :style="{ '--wuk-radio-box-size-wuk': '1.4rem' }"
          @change="(newLevel) => $emit('levelChange', newLevel)"
        />
      </template>
    </sword-popover-wuk>
  </div>
</template>

<script>
import SwordRadioGroupWuk from '@ui-kit/components/inputs/radios/SwordRadioGroup.vue';
import SwordPopoverWuk from '@ui-kit/components/popover/SwordPopover.vue';

export default {
  components: {
    SwordRadioGroupWuk,
    SwordPopoverWuk,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => {},
    },
    option: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.attention-level-popover::v-deep {
  .title {
    color: $context-color-5;
  }
  .info-content-box {
    padding: 0;
    overflow: hidden;

    // Always opened
    &.box-hidden {
      opacity: 1;
      visibility: visible;
    }
    .sword-radio-input-wrapper-wuk {
      font-size: 1.3em;
    }
    .sword-help-text-wuk,
    .sword-input-error-wuk {
      display: none;
    }
  }
  .content {
    width: 11rem;
    padding: 1rem;
    background-color: $color-white;
    z-index: 1;
    overflow: auto;
    cursor: auto;
  }
}
</style>
